import { useYellowhiveFlowsConfigureStore } from '@flows/src/store/zustand/flows-configure/yellowhiveFlowsConfigureStore';

type Page = 'insurances' | 'companies' | 'coverages';

interface HookResponse {
  handleSelectAll: (items: string[]) => void;
  handleDeselectAll: (mandatoryItems?: string[]) => void;
}

const useYellowhiveFlowsConfigureSelectAllButtonProps = (
  page: Page,
  insuranceId?: string,
): HookResponse => {
  const setCoverages = useYellowhiveFlowsConfigureStore(
    (state) => state.setCoverages,
  );

  const handleSelectAll = (items: string[]) => {
    if (page === 'coverages') {
      setCoverages(insuranceId || '', items);
    }
  };

  const handleDeselectAll = (mandatoryItems: string[] = []) => {
    if (page === 'coverages') {
      // Only deselect optional coverages, keep mandatory ones selected
      setCoverages(insuranceId || '', mandatoryItems);
    }
  };

  return {
    handleSelectAll,
    handleDeselectAll,
  };
};

export default useYellowhiveFlowsConfigureSelectAllButtonProps;
